import { render, staticRenderFns } from "./ToHospClinDoc.vue?vue&type=template&id=66341f61"
import script from "./ToHospClinDoc.vue?vue&type=script&lang=js"
export * from "./ToHospClinDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports